<template>
    <div>
        <app-navigation/>
        <app-banner
          backgroundUrl="/press/media-header.jpeg"
          :headerButtons="headerButtons"
          backgroundSize="cover"
          title="EPIWATCH® in the Media"
          description="Explore our media coverage and press releases, featuring the latest news about EPIWATCH® across radio interviews, article, and publications"
        />
        <div>
          <div :class="mobile ? 'white-section-mobile' : 'white-section'" style="width: 100%; max-width: 1500px; margin: 0 auto; height: 100%; padding:5%">
            <div :class="mobile ? 'section-title-mobile' : 'section-title'" id="Press">Media</div>
            <div class="card-grid">
              <div
                :v-if="!loading"
                v-for="(item, index) in media.slice(0, visibleCount)"
                :key="index"
                class="card"
              >
                <div>
                  <img :src="item.logo" alt="logo" class="card-logo" />
                  <h2 class="card-title">{{ item.title }}</h2>
                  <p class="card-date">{{ item.date }}</p>
                </div>
              </div>
            </div>
            <div class="show-more-container" v-if="media.length > visibleCount">
              <button @click="showMore" class="show-more-button">
                Show next
              </button>
            </div>
          </div>
          <div class="media-blue">
            <div class="divider">
              <span>Social</span>
            </div>
            <div style="max-width: 1500px; margin: auto;">
              <div class="grid-container">
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml"></div>
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml2"></div>
                <div ref="tweetContainer" class="tweet-container" v-html="tweetHtml3"></div>

              </div>
            </div>
          </div>
        </div>
        <app-footer/>
    </div>
</template>

<script>
// @ is an alias to /src
import AppNavigation from '@/components/AppNavigation.vue'
import AppFooter from '@/components/AppFooter.vue'
import AppBanner from '@/components/AppBanner.vue'
import axios from 'axios'

export default {
  name: 'Media',
  components: {
      AppNavigation,
      AppFooter,
      AppBanner,
  },
  data: () => ({
    mobile: null,
    windowWidth: null,
    headerButtons: [],
    videoCarousel: 0,
    visibleCount: 6,
    videos: [
      {url: "https://www.youtube.com/embed/u9JEuL6mCcw", des: "Introduction to Epiwatch"},
      {url: "https://www.youtube.com/embed/KH4Qulb8Tok", des: "EPIWATCH Launches Hindi Version"},
      {url: "https://www.youtube.com/embed/CpL6HxUYDC8", des: "Professor Raina MacIntyre on a panel at The Brookings Institute Panel on biosafety and COVID-19 origins."}
    ],
    media: null,
    loading: true,
    tweetHtml: `
        <blockquote class="twitter-tweet"><p lang="en" dir="ltr">(28 May - 03 June) The EPIWATCH team reviews global outbreaks daily and provides you with a summary every week. This week, there has been a 4th case of <a href="https://twitter.com/hashtag/haemorrhagic_fever?src=hash&amp;ref_src=twsrc%5Etfw">#haemorrhagic_fever</a> in the <a href="https://twitter.com/hashtag/Kurdistan_Region?src=hash&amp;ref_src=twsrc%5Etfw">#Kurdistan_Region</a> of <a href="https://twitter.com/hashtag/Iraq?src=hash&amp;ref_src=twsrc%5Etfw">#Iraq</a>, resulting in 1 fatality in 2 months, &amp; <a href="https://twitter.com/hashtag/Thailand?src=hash&amp;ref_src=twsrc%5Etfw">#Thailand</a> has issued a public… <a href="https://t.co/WeH0jkCUx1">pic.twitter.com/WeH0jkCUx1</a></p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://twitter.com/EPIWATCH_bsp/status/1930781409561698588?ref_src=twsrc%5Etfw">June 6, 2025</a></blockquote>
      `,
    tweetHtml2: `<blockquote class="twitter-tweet">
        <p lang="en" dir="ltr">
          A fourth death from <a href="https://twitter.com/hashtag/H5N1?src=hash&amp;ref_src=twsrc%5Etfw">#H5N1</a> has been reported in <a href="https://twitter.com/hashtag/Cambodia?src=hash&amp;ref_src=twsrc%5Etfw">#Cambodia</a> after an 11-year-old boy became unwell and passed away. <a href="https://t.co/UX20Fg5GIC">https://t.co/UX20Fg5GIC</a></p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://twitter.com/EPIWATCH_bsp/status/1929422170910077284?ref_src=twsrc%5Etfw">June 2, 2025</a></blockquote>`,
    tweetHtml3: `<blockquote class="twitter-tweet"><p lang="en" dir="ltr">(21 - 27 May 2025) The EPIWATCH team reviews global outbreaks daily and provides you with a summary every week. This week, an <a href="https://twitter.com/hashtag/unknown_outbreak?src=hash&amp;ref_src=twsrc%5Etfw">#unknown_outbreak</a> in <a href="https://twitter.com/hashtag/Cooch_Behar?src=hash&amp;ref_src=twsrc%5Etfw">#Cooch_Behar</a>, <a href="https://twitter.com/hashtag/India?src=hash&amp;ref_src=twsrc%5Etfw">#India</a>: 3 cows &amp; 4 goats died early April. Within weeks, 3 of 5 family members caring for them also died from fever &amp;… <a href="https://t.co/jm4uapXsF9">pic.twitter.com/jm4uapXsF9</a></p>&mdash; EPIWATCH (@EPIWATCH_bsp) <a href="https://twitter.com/EPIWATCH_bsp/status/1928285879115862111?ref_src=twsrc%5Etfw">May 30, 2025</a></blockquote>`,
    
  }),
  created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    async mounted() {
      this.$nextTick(() => {
        if (window.twttr?.widgets?.load) {
          window.twttr.widgets.load();
        }
      });
      this.checkScreen();
      this.fetch_media().then((data) => {
        this.media = data
        this.loading = false
      })
      this.loadTwitterWidgets();
    },
    methods: {
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
        return;
      },
      fetch_media() {
        return new Promise((resolve, reject) => {
          axios.get("data/media.json").then((response) => {
            resolve(response.data)
          })
          .catch((e) => {
            reject(e)
          })
          .finally(() => {})
        })
      },
      showMore() {
        this.visibleCount += 6;
      },
      loadTwitterWidgets() {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.async = true;
        script.onload = resolve;
        document.body.appendChild(script);
        
      });
    }
    },
  
}
</script>

<style>
.grid-container {
  column-count: 3;
  column-gap: 1rem;
}
@media (max-width:600px) {
  .grid-container {
    column-count: 1;
  }
}

.tweet-box {
  height: 400px;
  overflow-y: auto;
}


.v-btn__content {
  width: 100%;
  white-space: normal;
}

a {
  text-decoration: none;
}
</style>